<template>
  <v-dialog v-model="show" max-width="700" scrollable>
    <v-form ref="form" @submit.prevent="submit">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.stop="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ WindowLable }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items> </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-text-field v-model="title" label="Name"> </v-text-field>
          
           <v-select
              v-model="feederType"
              :items="feederTypes"
              item-text="title"
              item-value="title"
              label="Feeder Type"
            />

            <!-- <Selectcustom
              Lable="Feeder Type"
              DataSource="feederTypes"
              @SelectedItem="setval"
              :selectedValue="feederType"
              itemText="title"
              itemValue="title"
            /> -->
          
          <v-text-field
            v-model="resistanceOhmsPerKm"
            :rules="numberRules"
            label="Resistance (Ohms/Km)"
            type="number"
          >
          </v-text-field>
          <v-text-field
            v-model="reactanceOhmsPerKm"
            :rules="numberRules"
            label="Reactance (Ohms/Km)"
            type="number"
          >
          </v-text-field>
          <v-text-field
            v-model="peakCurrentCarryingCapacityAmps"
            :rules="numberRules"
            label="Peak Current Carrying Capacity (Amps)"
            type="number"
          >
          </v-text-field>
          <v-checkbox v-model="isPublished" color="primary" hide-details>
            <template v-slot:label> Published </template>
          </v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="primary" @click.stop="show = false"
            >Close</v-btn
          >
          <v-btn outlined color="primary" @click="submit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { bus } from "../main";
import conductorService from "@/libs/conductorService";
import ConductorStore from "@/services/conductorstore.js";
export default {
  name: "newEditConductorType",
  props: ["visible", "conductorData", "EditMode"],
 
  data() {
    return {
      WindowLable: "New Conductor Type",
      id: "",
      title: "",
      feederType: "",
      feederTypes: [{id:1,title:"Overhead"},{id:2,title:"Underground"}],
      resistanceOhmsPerKm: "",
      reactanceOhmsPerKm: "",
      peakCurrentCarryingCapacityAmps: "",
      isPublished: false,
      dialog: false,
      numberRules: [
        (v) => !!v || "Required",
        (v) => v >= 0 || "Negative value not allowed",
        (v) => v <= 1000 || "Max should not be 1000 ",
      ],
      inputRules: [(v) => !!v || "This field is required"],
    };
  },
  computed: {
    show: {
      get() {
        if (this.EditMode) {
          this.FillData();
        }
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    setval(e) {
      if (e.datasource === "feederTypes") {
        this.feederType = e.value;
      }
      else
      {
        this.feederType = null;
      }

    },
    initFormControls() {
      this._id = "";
      this.title = "";
      this.feederType =null;
      this.resistanceOhmsPerKm = "";
      this.reactanceOhmsPerKm = "";
      this.peakCurrentCarryingCapacityAmps = "";
      this.isPublished = false;
    },

    async saveAction(payload, _status, statusMessage) {
      bus.$emit("SaveNotification", _status, statusMessage);
      if (_status === "OK") {
        bus.$emit(
          "justAddedConductorRecord",
          await this.getLatestRecord(payload._id)
        );
        this.$refs.form.reset();
        this.initFormControls();
        this.$emit("close");
      }
    },
    async upodateAction(payload, _status, statusMessage) {
      bus.$emit("updateNotification", _status, statusMessage);
      if (_status === "OK") {
        bus.$emit(
          "justEditedConductorRecord",
          await this.getLatestRecord(payload._id)
        );
        this.initFormControls();
        this.$emit("close");
      }
    },
    async getLatestRecord(id) {
      const res = await conductorService.getConductor(id);
      return res.data;
    },
    FillData() {
      this.WindowLable = "Edit Conductor Type";
      this._id = this.conductorData._id;
      this.title = this.conductorData.title;
      this.resistanceOhmsPerKm = this.conductorData.resistanceOhmsPerKm;
      this.reactanceOhmsPerKm = this.conductorData.reactanceOhmsPerKm;
      this.peakCurrentCarryingCapacityAmps =
        this.conductorData.peakCurrentCarryingCapacityAmps;
      this.isPublished = this.conductorData.isPublished;
      this.feederType = this.conductorData.feederType;
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.Loading = true;

        if (this.EditMode === false) {
          const payload = {
            title: this.title,
            feederType : this.feederType,
            resistanceOhmsPerKm: this.resistanceOhmsPerKm,
            reactanceOhmsPerKm: this.reactanceOhmsPerKm,
            peakCurrentCarryingCapacityAmps:
              this.peakCurrentCarryingCapacityAmps,
            isPublished: this.isPublished,
          };

          await ConductorStore.methods
            .addConductorType(payload)
            .then((res) => {
              const currnData = {
                _id: res.data._id,
                title: this.title,
                feederType:this.feederType,
                resistanceOhmsPerKm: this.resistanceOhmsPerKm,
                reactanceOhmsPerKm: this.reactanceOhmsPerKm,
                peakCurrentCarryingCapacityAmps:
                  this.peakCurrentCarryingCapacityAmps,
                isPublished: this.isPublished,
              };
              this.saveAction(currnData, res.data._status);
            })
            .catch((error) => {
              this.saveAction(null, 400, error);
            });
        } else if (this.EditMode === true) {
          await ConductorStore.methods
            .editConductorType(
              this._id,
              this.title,
              this.feederType,
              this.resistanceOhmsPerKm,
              this.reactanceOhmsPerKm,
              this.peakCurrentCarryingCapacityAmps,
              this.isPublished
            )
            .then((res) => {
              this.Loading = false;
              const currenData = {
                _id: res.data._id,
                title: this.title,
                feederType:this.feederType,
                resistanceOhmsPerKm: this.resistanceOhmsPerKm,
                reactanceOhmsPerKm: this.reactanceOhmsPerKm,
                peakCurrentCarryingCapacityAmps:
                  this.peakCurrentCarryingCapacityAmps,
                isPublished: this.isPublished,
              };
              this.upodateAction(currenData, res.data._status);
            })
            .catch((error) => {
              this.upodateAction(400, error);
            });
        }
      }
    },
  },
};
</script>